import { render, staticRenderFns } from "./ApplicationManagement.vue?vue&type=template&id=634dde5d&scoped=true"
import script from "./ApplicationManagement.vue?vue&type=script&lang=js"
export * from "./ApplicationManagement.vue?vue&type=script&lang=js"
import style0 from "./ApplicationManagement.vue?vue&type=style&index=0&id=634dde5d&prod&scoped=true&lang=css"
import style1 from "./ApplicationManagement.vue?vue&type=style&index=1&id=634dde5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dde5d",
  null
  
)

export default component.exports